import { CustomizedTypography } from '@components/Customized';
import {
  CapaQuotationRfqPurchaseOrder,
  CapaRfqPurchaseOrderInspectionType
} from '@generated/graphql';
import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import PurchaseOrderViewInfoEntry from './PurchaseOrderViewInfoEntry';
import useStyles from './useStyles';

interface Props {
  currentItem?: CapaQuotationRfqPurchaseOrder;
}

const PurchaseOrderInspectionInfo = ({ currentItem }: Props) => {
  const classes = useStyles();

  const { details } = useDocumentsInspectionInfoStyles();
  const inspectionPeriod = currentItem?.inspectionPeriod ?? 0;
  const inspections = currentItem?.inspections ?? [];

  const apperanceInspection = inspections.filter(
    (inspection) =>
      inspection.inspectionType === CapaRfqPurchaseOrderInspectionType.Surface
  );
  const dimensionInspection = inspections.filter(
    (inspection) =>
      inspection.inspectionType === CapaRfqPurchaseOrderInspectionType.Dimension
  );
  const functionInspection = inspections.filter(
    (inspection) =>
      inspection.inspectionType ===
      CapaRfqPurchaseOrderInspectionType.Functionalty
  );
  const etcInspection = inspections.filter(
    (inspection) =>
      inspection.inspectionType === CapaRfqPurchaseOrderInspectionType.Etc
  );

  return (
    <div className={classes.wrapper + ' gutter'}>
      <CustomizedTypography variant="h4" fontWeight="500" gutterBottoms={8}>
        검수 조건
      </CustomizedTypography>
      <PurchaseOrderViewInfoEntry
        label="검수 기간"
        data={`납품일로부터 ${inspectionPeriod}일까지`}
      />
      {inspections?.length > 0 && (
        <PurchaseOrderViewInfoEntry
          label="검수 항목"
          data={
            <Box className={details}>
              {apperanceInspection?.length > 0 && (
                <ul>
                  <CustomizedTypography
                    variant="body2"
                    color={'textSecondary'}
                    gutterBottoms={8}
                  >
                    외관 검사
                  </CustomizedTypography>
                  {apperanceInspection?.map((inspection, index) => (
                    <li key={`${inspection.inspectionRequest}${index}`}>
                      <CustomizedTypography
                        variant="body1"
                        className="pre-line"
                      >
                        {inspection.inspectionRequest}
                      </CustomizedTypography>
                    </li>
                  ))}
                </ul>
              )}
              {dimensionInspection?.length > 0 && (
                <ul>
                  <CustomizedTypography
                    variant="body2"
                    color="textSecondary"
                    gutterBottoms={8}
                  >
                    치수 검사
                  </CustomizedTypography>
                  {dimensionInspection?.map((inspection, index) => (
                    <li key={`${inspection.inspectionRequest}${index}`}>
                      <CustomizedTypography
                        variant="body1"
                        className="pre-line"
                      >
                        {inspection.inspectionRequest}
                      </CustomizedTypography>
                    </li>
                  ))}
                </ul>
              )}
              {functionInspection?.length > 0 && (
                <ul>
                  <CustomizedTypography
                    variant="body2"
                    color="textSecondary"
                    gutterBottoms={8}
                  >
                    기능 검사
                  </CustomizedTypography>
                  {functionInspection?.map((inspection, index) => (
                    <li key={`${inspection.inspectionRequest}${index}`}>
                      <CustomizedTypography
                        variant="body1"
                        className="pre-line"
                      >
                        {inspection.inspectionRequest}
                      </CustomizedTypography>
                    </li>
                  ))}
                </ul>
              )}
              {etcInspection?.length > 0 && (
                <ul>
                  <CustomizedTypography
                    variant="body2"
                    color="textSecondary"
                    gutterBottoms={8}
                  >
                    기타 검사
                  </CustomizedTypography>
                  {etcInspection?.map((inspection, index) => (
                    <li key={`${inspection.inspectionRequest}${index}`}>
                      <CustomizedTypography
                        variant="body1"
                        className="pre-line"
                      >
                        {inspection.inspectionRequest}
                      </CustomizedTypography>
                    </li>
                  ))}
                </ul>
              )}
            </Box>
          }
        />
      )}
    </div>
  );
};

export default PurchaseOrderInspectionInfo;

const useDocumentsInspectionInfoStyles = makeStyles((theme) => ({
  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    '& ul': {
      '& li': {
        width: 'calc(100% - 20px)',
        display: 'list-item',
        listStyle: 'disc',
        transform: 'translateX(20px)',
        '& > h6': {
          wordBreak: 'break-all'
        }
      }
    }
  }
}));
